import Search from "antd/es/input/Search"
import React from "react"
import { groupBy } from "lodash";
import { Tag } from "antd";

export const FindWordSearchResultPage = () => {

    const resultData = {
        word: "Honey",
        definition: "A sweet, viscous food substance made by bees and some related insects.",
        occur_count: 5,
        alsoUsedIn: [{ sentence: "I love honey", bookId: "17", articleName: "剑17-1-3", articleId: "camb-17-1-3", sent_index: [7, 12], sent_id: 23 },
        { sentence: "We do not like honey", bookId: "17", articleName: "剑17-1-4", articleId: "camb-17-1-4", sent_index: [15, 20], sent_id: 45 }],
    }
    const alsoUsedInArrays = groupBy(resultData.alsoUsedIn, item => item.bookId)

    const alsoUsedInResults = (alsoUsedIn) => alsoUsedIn.map(item => {
        const sentence = item.sentence;
        const startIndex = item.sent_index[0];
        const endIndex = item.sent_index[1];
        return <>
            <p style={{ margin: '15px 0 0 0', color: '#3c91ceff', fontSize: 24, textDecoration: 'underline', cursor: 'pointer' }}>{sentence.slice(0, startIndex)}<strong style={{ color: '#e12222ff' }}>{sentence.slice(startIndex, endIndex)}</strong>{sentence.slice(endIndex)}</p>
            <p style={{ margin: '0 0 25px', color: 'grey' }}> from <span style={{ cursor: 'pointer' }}>{item.articleId}</span></p>
        </>
    })
    return <div style={{ minHeight: 'calc(100vh - 160px)', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', padding: 20 }}>
        <div style={{ paddingTop: 50, display: 'flex', flexDirection: 'row', gap: 20, width: '100%', alignItems: 'flex-start', marginBottom: 30 }}>
            <h1 style={{ marginTop: 0, marginBottom: 24, textAlign: 'center' }}>Find A Word</h1>

            <div>
                <Search style={{ maxWidth: 600, maxHeight: 34 }} classNames={{
                    button: {
                        content: 'my-classname'
                    },
                    count: "dd"
                }}
                    styles={{
                        button: {
                            icon: {
                                color: 'blue'
                            },
                            content: {
                                backgroundColor: 'blue',
                                color: 'white'
                            }
                        }
                    }} />
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', gap: 10 }}>
                    <h1>{resultData.word}</h1>
                    <p>Appeared in <strong>{resultData.occur_count}</strong> readings</p>
                </div>
                <p style={{ fontStyle: 'italic' }}>{resultData.definition}</p>
                {Object.keys(alsoUsedInArrays).map((key) => {

                    return (<>

                        <Tag key={key} color="orange" variant="outlined">
                            {key}
                        </Tag>
                        {alsoUsedInResults(alsoUsedInArrays[key])}
                    </>)
                })}
            </div>

        </div>


    </div>
}
